import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { from, Observable } from "rxjs";
import { StorageService } from "./storage.service";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root",
})
export class InterceptorService implements HttpInterceptor {
  constructor(
    private storageService: StorageService,
    private authService: AuthService
  ) { }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return from(this.handle(req, next));
  }

  private async handle(req: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {
    let request = req;
    if ((req.headers.get("Service") == "Prev" || req.url.includes("CustomerService"))
      && this.storageService.get("msal.idtoken")) {
      request = await this.getToken(request);
      return next.handle(request).toPromise();
    } else {
      return next.handle(request).toPromise();
    }
  }

  private async getToken(request: HttpRequest<any>) {
    let token = this.storageService.get("msal.idtoken");

    //Validar si está expirado
    const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
    let expired = (Math.floor((new Date).getTime() / 1000)) >= expiry;

    if (expired) {
      await this.authService.getTokenAsync();
      token = this.storageService.get("msal.idtoken");
    }

    request = request.clone({
      setHeaders: {
        Authorization: "Bearer " + token,
      },
    });

    return request;
  }
}
